module.exports = __webpack_public_path__ + "img/s1.abdc77b4.png";